import React from 'react';
import PropTypes from 'prop-types';

function ArrowsBackground({ color, opacity }) {
  return (
    <path
      d="M681.084 212.622C681.084 255.193 646.57 289.703 604 289.703C561.43 289.703 526.92 255.193 526.92 212.622C526.92 170.052 561.43 135.542 604 135.542C646.57 135.542 681.084 170.052 681.084 212.622Z"
      fill={color}
      fillOpacity={opacity}
    />
  );
}

ArrowsBackground.propTypes = {
  color: PropTypes.string,
  opacity: PropTypes.number,
};

ArrowsBackground.defaultProps = {
  color: '#000000',
  opacity: 1,
};

export default ArrowsBackground;
